import { render, staticRenderFns } from "./waiverPage.vue?vue&type=template&id=d4e1f5b2"
import script from "./waiverPage.vue?vue&type=script&lang=ts"
export * from "./waiverPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports